import { schema } from 'prosemirror-schema-basic'

export const peMarks = {
  ...schema.spec.marks.toObject(),
}
